var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.showVideoBg)?_c('video',{staticClass:"video-bg",attrs:{"loop":"loop","autoplay":"autoplay","muted":"muted"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4"}})]):_vm._e(),_c('div',{staticClass:"login-comp"},[_c('login-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }